<template>
  <div class="task-child">
    <div class="report-image-grid" v-if="!loading">
      <CardTypeSelect
        v-on:card-create-event="cardCreateEvent($event)"
        :graphs="graphs_"
        v-if="step===0"
      />
    </div>
    <div class="card-grid-item report-modal" v-else>
      <div class="block">
        <p class="circle">
          <span class="ouro ouro3">
            <span class="left">
              <span class="anim"></span>
            </span>
            <span class="right">
              <span class="anim"></span>
            </span>
          </span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { status_values, dash_tasks } from "../utils/env";
import CardTypeSelect from "./card/CardTypeSelect";

export default {
  name: "CardCreate",
  components: {
    CardTypeSelect
  },
  props: {
    task: { type: Object },
    header_status: { type: Object },
    graphs: {type: Array, value: []},
    api: null,
    config: null
  },
  data: function() {
    return {
      status_values: status_values,
      dash_tasks: dash_tasks,
      graphs_: this.graphs,
      data_in: [],
      status: null,
      graph: null,
      task_: this.task,
      header_status_: this.header_status,
      loading: false
    };
  },
  methods: {
    search: function() {
      this.load(true);
      let promiseTosearch = new Promise((resolve,reject) => {
        setTimeout(() => {
            if(this.graphs && this.graphs.length>=0) {
            resolve(this.graphs)
            }
            reject('Nessuna risorsa creabile.')
            }, 1000);
          });

      promiseTosearch.then(
          graphs => {
              let graph_filtered = graphs.filter((elem) => {
                let test_filter = (this.header_status_.text_filter!==null)?this.header_status_.text_filter.toLowerCase():"";
                console.log('FILTER TEXT : ', test_filter);
                let test =  (elem.description.toLowerCase().includes(test_filter) || elem.name.toLowerCase().includes(test_filter));
                return test;
            });
            this.data_in = this.graphs;
            this.graphs_ = graph_filtered;
            this.load(false);
          },
          error => {
            console.log(error);
            this.load(false);
          }
        );
    },
    cardCreateEvent: function(event) {
      switch (event.topic) {
        case "graph-selected":
          this.graph = event.graph;
          window.open(`/add-resource/${event.graph.graphid}`,'_blank');
          break;
      }
    },
    load(value) {
      this.loading = value;
    }
  },
  computed: {
    step: {
      get() {
        return this.task_.workflow_current_index;
      },
      set(value) {
        this.task_.workflow_current_index = value;
        this.graph = null;
        this.$emit("dash-event", {
          topic: "workflow-current-index",
          workflow_current_index: value
        });
      }
    }
  },
  watch: {
/*     step: function() {
      if (this.step === 0) {
        this.graph = null;
      }
    }, */
    header_status: {
      handler() {
        if (this.step === 0) this.search();
      },
      deep: true
    }
  },
  mounted: function() {
    this.step = 0;
  }
};
</script>

<style scoped>
.workflow-child {
  min-height: 240px;
  padding-left: 60px;
}

.panel-heading {
  height: 50px;
  margin-top: 0px !important;
  padding: 2px 2px 2px 2px;
  background-color: #ffffff;
  border-width: 0px 0px 0px 0px;
  border-style: solid;
  border-color: #ffffff;
}

.panel-footer {
  border-width: 0px 0px 0px 0px;
  border-color: #000000;
  border-style: solid;
}

.panel-body {
  border: 1px solid;
  border-color: #9e5757;
}

button.btn {
  margin: 10px;
  float: left;
}

.panel-heading button {
  float: left;
  margin: 4px;
}

.panel-heading > a {
  border-width: 0px 0px 0px 1px;
  border-color: #ffffff;
  border-style: solid;
}

.panel-heading > div {
  border-width: 0px 0px 0px 0px;
  border-color: #ffffff;
  border-style: solid;
}

.panel-heading > div > a {
  height: 30px;
  padding: 4px 6px;
}
.panel-heading button.btn {
  top: 4px;
  padding: 4px 4px 4px 4px;
}

.form-control {
  max-width: 160px;
  margin-left: 4px;
}

div.well {
  padding: 4px 4px 4px 4px;
  max-height: 36px;
  width: 400px;
  margin: 2px 2px 2px 2px;
  vertical-align: middle;
  font-size: 16px;
}

div.well > * {
  max-height: 36px;
  margin: 4px 4px 4px 4px;
}

div[class^="col-"] {
  padding: 2px 2px 2px 2px;
}

div#app .form-control {
  max-width: 100%;
}

.card-grid-item {
  width: 400px;
  text-overflow: ellipsis;
  word-wrap: break-word;
  padding-bottom: 0px;
}
.car-grid-item * {
  display: block;
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.panel-body {
  min-height: 251px;
}

.addScroll {
  overflow-y: auto;
  height: 200px;
}

.card-grid-item.report-modal {
  min-height: 240px;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.1);
  text-align: center;
  display: table;
  width: 100%;
  border: 0px;
}

#app .block {
  display: table-cell;
  vertical-align: middle;
  background-color: rgba(255, 255, 255, 0.1);
}
</style>

